export const MatchDefinitionRole = () => {
    return (definitions, roles) => {
        const filtered = [];
        angular.forEach(definitions, (definition) => {
            const inArray = definition.roles.reduce((a, role) => {
                return a || roles.indexOf(role._id) > -1;
            }, false);
            inArray && filtered.push(definition);
        });
        return filtered;
    };
};

export const Range = () => {
    return (input, total) => {
        total = parseInt(total);
        for (let i = 0; i < total; i++) {
            input.push(i);
        }
        return input;
    };
};

export const PasswordCount = () => {
    return (value, peak) => {
        value = angular.isString(value) ? value : '';
        peak = isFinite(peak) ? peak : 8;
        return value && (value.length > peak ? peak + '+' : value.length);
    };
};

export const IncludedInURL = () => {
    return (headers) => {
        const filtered = [];
        angular.forEach(headers, (header) => {
            if (header.includeInURL) {
                filtered.push(header);
            }
        })
        return filtered;
    };
};

export const FilterWorkflow = () => {
    return (checklists, workflowFilters) => {
        const filtered = [];
        angular.forEach(checklists, (checklist) => {
            let tagMatch = false
            let userMatch= false
            let dateFromMatch = false
            let dateToMatch = false
            let dateFrom = null
            let dateTo = null
            let updated = moment(checklist.updated, "DD-MMM-YYYY")
            if (workflowFilters.dateFrom) {
                dateFrom = moment(workflowFilters.dateFrom, "DD-MMM-YYYY")
            }
            if (workflowFilters.dateTo) {
                dateTo = moment(workflowFilters.dateTo, "DD-MMM-YYYY")
                dateTo.hour(23)
                dateTo.minute(59)
                dateTo.second(59)
            }
            if (workflowFilters.user._id === "all" || checklist.user && workflowFilters.user._id === checklist.user._id) {
                userMatch = true;
            }
            if (workflowFilters.tag._id === "any" || _.find(checklist.tags, { '_id': workflowFilters.tag._id })) {
                tagMatch = true;
            }
            if (dateFrom == null || updated.isAfter(dateFrom)) {
                dateFromMatch = true;
            }
            if (dateTo == null || updated.isBefore(dateTo)) {
                dateToMatch = true;
            }
            if (tagMatch && userMatch && dateFromMatch && dateToMatch) {
                filtered.push(checklist);
            }
        });
        return filtered;
    };
};